const VENDORAPI = {
    ADDVENDOR: `vendor/vendor`,
    GETVENDOR: `vendor/vendors`,
    DELETEBILLER: (userId) => `users/user/${userId}`,
    EDITBILLER: (userId) => `vendor/vendor/${userId}`
}

export default VENDORAPI;